import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; 
import { useNavigate } from "react-router-dom";

const MyProfile = () => {
  const navigate = useNavigate();
  const [userdata, setUserdata] = React.useState({
    Tkn: "",
    UserID: "",
    UserAlias: "",
    UserGender: "",
    UserEmail: "",
    UserPhone: "",
    UserAddress: "",
    UserNok: "",
    UserNokPhone: "",
    UserNokRel: "",
    UserMariral: "",
    UserSpouse: "",
    UserSpousePhone: "",
    UserZone: "",
    UserImg: "",
    UserMinistries: [],
    UserCellGroups: [],
  });

  useEffect(() => {
    const asyncFetch = async () => {
      const Tkn = localStorage.getItem("Tkn");
      const UserID = localStorage.getItem("UserID");
      const UserAlias = localStorage.getItem("UserAlias");
      const UserGender = localStorage.getItem("UserGender");
      const UserEmail = localStorage.getItem("UserEmail");
      const UserPhone = localStorage.getItem("UserPhone");
      const UserAddress = localStorage.getItem("UserAddress");
      const UserZone = localStorage.getItem("UserZone");
      const UserImg = localStorage.getItem("UserImg");
      const UserNok = localStorage.getItem("UserNok");
      const UserNokPhone = localStorage.getItem("UserNokPhone");
      const UserNokRel = localStorage.getItem("UserNokRel");
      const UserMariral = localStorage.getItem("UserMarital");
      const UserSpouse = localStorage.getItem("UserSpouse");
      const UserSpousePhone = localStorage.getItem("UserSpousePhone");
      let UserMinistries = [];
      let UserCellGroups = [];
      try {
        let value = localStorage.getItem("UserMinistries");
        if (value != null) {
          // do something
          const AsyncUserMinistries = localStorage.getItem(
            "UserMinistries"
          );
          UserMinistries = JSON.parse(AsyncUserMinistries);
        }
      } catch (error) {
        console.log(error);
      }
      try {
        let value = localStorage.getItem("UserCellGroups");
        if (value != null) {
          // do something
          const AsyncUserCellGroups = localStorage.getItem(
            "UserCellGroups"
          );
          UserCellGroups = JSON.parse(AsyncUserCellGroups);
        } else {
          UserCellGroups = [];
        }
      } catch (error) {
        console.log(error);
      }

      if (UserID) {
        setUserdata({
          Tkn,
          UserID,
          UserAlias,
          UserGender,
          UserEmail,
          UserPhone,
          UserAddress,
          UserZone,
          UserImg,
          UserNok,
          UserNokPhone,
          UserNokRel,
          UserMariral,
          UserSpouse,
          UserSpousePhone,
          UserMinistries,
          UserCellGroups,
        });
        console.log("Set done");
      }
    };
    asyncFetch();
  }, []);

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.headerContainer}>
        <button onClick={() => navigate(-1)} style={styles.backButton}>
          <ArrowBackIcon style={styles.backIcon} />
        </button>
        <h4 style={styles.heading}>My Profile</h4>
      </div>
      <div style={styles.header}>
        <img
          src={userdata.UserImg}
          alt="User"
          style={styles.userImage}
        />
        <h2 style={styles.userName}>Hi! {userdata.UserAlias}</h2>
      </div>

      {/* Profile Details */}
      <div style={styles.detailsContainer}>
        {/* Gender */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Gender</span>
          <span style={styles.detailValue}>{userdata.UserGender}</span>
        </div>

        {/* Email */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Email</span>
          <span style={styles.detailValue}>{userdata.UserEmail}</span>
        </div>

        {/* Phone */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Phone</span>
          <span style={styles.detailValue}>{userdata.UserPhone}</span>
        </div>

        {/* Address */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Address</span>
          <span style={styles.detailValue}>{userdata.UserAddress}</span>
        </div>

        {/* Zone */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Zone</span>
          <span style={styles.detailValue}>{userdata.UserZone}</span>
        </div>

        {/* Cell Group */}
        {userdata.UserCellGroups.length > 0 && (
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Cell Group</span>
            <span style={styles.detailValue}>
              {userdata.UserCellGroups[0].SmallGroupName}
            </span>
          </div>
        )}

        {/* Ministries */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Ministries</span>
          <div style={styles.detailValue}>
            {userdata.UserMinistries.length > 0 ? (
              userdata.UserMinistries.map((ministry, index) => (
                <span key={index} style={styles.ministryItem}>
                  {ministry.MinistryName}
                </span>
              ))
            ) : (
              <span style={styles.noMinistryText}>None Joined</span>
            )}
          </div>
        </div>

        {/* Next of Kin */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Next of Kin</span>
          <span style={styles.detailValue}>{userdata.UserNok}</span>
        </div>

        {/* Next of Kin Phone */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Next of Kin Phone</span>
          <span style={styles.detailValue}>{userdata.UserNokPhone}</span>
        </div>

        {/* Next of Kin Relationship */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Next of Kin Relationship</span>
          <span style={styles.detailValue}>{userdata.UserNokRel}</span>
        </div>

        {/* Marital Status */}
        <div style={styles.detailItem}>
          <span style={styles.detailLabel}>Marital Status</span>
          <span style={styles.detailValue}>{userdata.UserMariral}</span>
        </div>

        {/* Spouse Details (if married) */}
        {userdata.UserMariral === "Married" && (
          <>
            <div style={styles.detailItem}>
              <span style={styles.detailLabel}>Spouse Name</span>
              <span style={styles.detailValue}>{userdata.UserSpouse}</span>
            </div>
            <div style={styles.detailItem}>
              <span style={styles.detailLabel}>Spouse Phone</span>
              <span style={styles.detailValue}>{userdata.UserSpousePhone}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// Styles
const styles = {
  container: {
    padding: "20px",
    maxWidth: "500px",
    margin: "0 auto",
    marginBottom: "60px",
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '800px',
    marginBottom: '15px',
    position: 'relative'
  },
  backButton: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '50%',
    marginRight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    ':hover': {
      backgroundColor: '#f0f2f5'
    }
  },
  backIcon: {
    color: '#1a6363',
    fontSize: '28px'
  },
  heading: {
    flex: 1,
    textAlign: 'center',
    fontSize: '24px',
    color: '#1a6363',
    fontWeight: '600',
    margin: 0,
    paddingRight: '52px'
  },
  profileHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: '20px'
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    backgroundColor: '#f0f2f5',
    marginBottom: '15px',
    overflow: 'hidden'
  },
  userImage: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    marginBottom: "10px",
  },
  userImage: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    margin: "0 auto 10px",
    display: "block"
  },
  detailsContainer: {
    width: "100%",
    maxWidth: "500px",
  },
  detailItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #1a636330",
    padding: "15px 0",
  },
  detailLabel: {
    fontSize: "16px",
    color: "#000000",
    fontWeight: "500",
  },
  detailValue: {
    fontSize: "16px",
    color: "#1a6363",
    textAlign: "right",
    maxWidth: '60%',
    wordBreak: 'break-word'
  },
  ministryItem: {
    display: "block",
    marginBottom: "5px",
  },
  noMinistryText: {
    color: "#00000050",
  },
};


export default MyProfile;